import React, { useCallback, useEffect, useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsArrowDown, BsDownload } from "react-icons/bs";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import FileDownloader from "../../../../components/UI/Button/FileDownloader";
import ButtonImage from "../../../../components/UI/Button/ButtonImage";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import DateTime from "../../../../components/Formatters/DateTime";
import AndamentoAlteracaoExecutorDetalhamento from "./AndamentoAlteracaoExecutorDetalhamento";
import CustomExpanderIcon from "../../../../components/UI/DataTable/CustomExpanderIcon";
import useAndamentoAlteraaoExecutor from "../hooks/useAndamentoAlteraaoExecutor";
import constants from "../../../Constants";

const andamentoAlteracaoExecutor = { exibir: () => {} };

const documento = (row) => {
  andamentoAlteracaoExecutor.exibir(row);
};

const Cell = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const acoesCell = (row) => {
  if (!row.documento && row.situacao === "Gerado") {
    return (
      <ButtonImage
        className="btn-lg text-success pa-0 p-0"
        buttonImage={<BsDownload size="15" color="#e37023" />}
        tooltipImage={row.situacao === "Gerado" ? "Documento Gerado" : "Não foi encontrado documento para baixar"}
        onClick={() => documento(row)}
      />
    );
  }

  return <FileDownloader binario={row.documento} tooltip="Visualizar Documento" />;
};
const columns = [
  {
    width: "55px",
    selector: (row) => <CustomExpanderIcon row={row} emptyWhen={(item) => (item.anexos?.length ?? 0) === 0} />,
  },
  {
    name: "Andamento",
    selector: "andamento",
    maxWidth: "19%",
    center: true,
    sortable: true,
    cell: (row) => <DateTime value={row.andamento} stringFormat="dd/MM/yyyy HH:mm:ss" />,
  },
  {
    name: "Atividade",
    selector: "atividade",
    maxWidth: "35%",
    sortable: true,
    cell: (row) => Cell(row.atividade),
  },
  {
    name: "Situação",
    selector: "situacao",
    maxWidth: "11%",
    center: true,
    sortable: true,
  },
  {
    name: "Origem",
    selector: "fgOrigem",
    center: true,
    sortable: true,
  },
  {
    name: "Usuário",
    selector: "usuario",
    maxWidth: "24%",
  },
  {
    name: "Ações",
    center: true,
    maxWidth: "1%",
    cell: acoesCell,
  },
];

const AndamentoAlteracaoExecutorOS = ({ alteracaoExecutorOS }) => {
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const setSelection = useState({})[1];

  const { setDocParams } = useAndamentoAlteraaoExecutor();

  andamentoAlteracaoExecutor.exibir = (row) => {
    setDocParams({ sqAlteracaoExecutor: alteracaoExecutorOS.sqAlteracaoExecutor, sqAndamento: row.sqAndamento });
  };

  const { request: requestAndamento, data, errors: error, isLoading } = useApiClient();

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  useEffect(() => {
    if (alteracaoExecutorOS?.sqAlteracaoExecutor !== "" || alteracaoExecutorOS?.sqAlteracaoExecutor !== undefined) {
      const params = {
        AlteracaoExecutorOS: alteracaoExecutorOS.sqAlteracaoExecutor,
        pageSize,
        pageNumber,
      };

      requestAndamento(apiRoutes.fiscalizacao.alteracaoexecutor.andamentoAlterExec, params);
    }
  }, [requestAndamento, alteracaoExecutorOS, pageSize, pageNumber]);

  useEffect(() => {
    if (data && data.result) {
      if (data.result.length && !data.result[0].totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados.`);
        return;
      }

      const preRows = data.result.map((item) => {
        const disabled = !(item.anexos?.length > 0);
        return { ...item, disabled };
      });

      setRows(preRows || []);
      setTotalRows(data.result.length ? data.result[0].totalRows : 0);
    }

    if (error) {
      toast.error(error.message);
    }
  }, [data, error]);

  return (
    <div style={{ width: "100%" }}>
      <DataTable
        noHeader
        keyField="sqAndamento"
        columns={columns}
        data={rows}
        expandableRows
        expandableRowsHideExpander
        expandOnRowClicked
        onRowExpandToggled={(expanded, row) => {
          setRows((curr) => {
            const itemIndex = curr.findIndex(
              (value) => value.sqAtividade === row.sqAtividade && value.sqAndamento === row.sqAndamento,
            );
            const items = [...curr];
            items[itemIndex] = { ...curr[itemIndex], expanded };
            return items;
          });
        }}
        expandableRowsComponent={AndamentoAlteracaoExecutorDetalhamento}
        expandableRowsComponentProps={{ anexos: alteracaoExecutorOS.anexos }}
        progressPending={isLoading}
        noDataComponent="Nenhum registro para exibir"
        progressComponent={<TextSpinner />}
        defaultSortFieldId={1}
        sortIcon={<BsArrowDown />}
        pagination
        sortable
        paginationTotalRows={totalRows}
        selectableRows={false}
        onSelectedRowsChange={(state) => {
          setSelection(state.selectedRows);
        }}
        pointerOnHover
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationComponentOptions={constants.paginationComponentOptions}
        paginationPerPage={pageSize}
      />
    </div>
  );
};

export default AndamentoAlteracaoExecutorOS;
